var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
var OutsourceCollectionService = /** @class */ (function () {
    function OutsourceCollectionService() {
    }
    /**
     * 委外催收列表
     */
    OutsourceCollectionService.prototype.earchCaseOutList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourceCollectionManageController.searchCaseOutList,
            data: {
                overdueAmountStart: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountEnd: data.overdueAmount ? data.overdueAmount.max : '',
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                followInTimeStart: FilterService.dateRanageFormat(data.followInTime).start,
                followInTimeEnd: FilterService.dateRanageFormat(data.followInTime).end,
                outTimeStart: FilterService.dateRanageFormat(data.outTimeDate).start,
                outTimeEnd: FilterService.dateRanageFormat(data.outTimeDate).end,
                outEndDateStart: FilterService.dateRanageFormat(data.outEndDate).start,
                outEndDateEnd: FilterService.dateRanageFormat(data.outEndDate).end,
                followUpTimeStart: FilterService.dateRanageFormat(data.followUpTime).start,
                followUpTimeEnd: FilterService.dateRanageFormat(data.followUpTime).end,
                applyStatus: data.applyStatus,
                leaveCaseFlag: data.leaveCaseFlag,
                customerCategory: data.customerCategory,
                outsourceId: data.outsourceId,
                collectorRealName: data.collectorRealName,
                area: data.area,
                personalName: data.personalName,
                turnSource: data.turnSource,
                productName: data.productName,
                productCategory: data.productCategory,
                overduePeriod: data.overduePeriod,
                outAmount: data.outAmount,
                mobileNo: data.mobileNo,
                localAddress: data.localAddress,
                idCard: data.idCard,
                currentCollector: data.currentCollector,
                outBatch: data.outBatch,
                caseNumber: data.caseNumber,
                cityCode: data.cityCode,
                followupBack: data.followupBack,
                outSourceType: data.outSourceType,
                labelName: data.labelName,
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 委外管理-委外催收案件-回收案件
     */
    OutsourceCollectionService.prototype.caseRecovery = function (data) {
        return this.netService.send({
            server: domainService.outsourceCollectionManageController.caseRecovery,
            data: data
        });
    };
    /**
     * 委外管理-委外催收案件-留案
     */
    OutsourceCollectionService.prototype.caseStay = function (data) {
        return this.netService.send({
            server: domainService.outsourceCollectionManageController.caseStay,
            data: data
        });
    };
    /**
     * 委外管理-委外催收案件-导入电催跟进
     */
    OutsourceCollectionService.prototype.importMobileUrge = function (data) {
        return this.netService.send({
            server: domainService.outsourceCollectionManageController.importMobileUrge,
            data: data
        });
    };
    /**
     * 委外管理-委外催收案件-导入外访跟进
     */
    OutsourceCollectionService.prototype.importOutVisit = function (data) {
        return this.netService.send({
            server: domainService.outsourceCollectionManageController.importOutVisit,
            data: data
        });
    };
    /**
     * 委外管理-委外催收案件-导入外访附件
     */
    OutsourceCollectionService.prototype.importOutVisitEnclosure = function (data) {
        return this.netService.send({
            server: domainService.outsourceCollectionManageController.importOutVisitEnclosure,
            data: data
        });
    };
    /**
     * 委外管理-委外催收案件-取消留案
     */
    OutsourceCollectionService.prototype.unCaseStay = function (data) {
        return this.netService.send({
            server: domainService.outsourceCollectionManageController.unCaseStay,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceCollectionService.prototype, "netService", void 0);
    return OutsourceCollectionService;
}());
export { OutsourceCollectionService };
